import { RemoteData } from 'app/infrastructure/remote-data';
import { ApiResponse } from 'app/types-shared';
import { endpoint } from './constants';
import { LockedCase, RootCode, UnlockCaseArgs } from './types';

export const api = {
  getLockedBy: async (caseId: number): Promise<LockedCase> => {
    const response = await new RemoteData(endpoint.lockedBy(caseId))
      .resource<ApiResponse<LockedCase>>()
      .all();
    return response.data;
  },

  discardUnlockCase: async (draftId: number) =>
    new RemoteData(endpoint.discardUnlockCase(draftId))
      .resource<void>()
      .httpDelete({}),

  choosePersonUnlockCase: async (args: UnlockCaseArgs) =>
    new RemoteData(endpoint.choosePersonUnlockCase(args))
      .resource<void>()
      .filter({ personId: args.personId })
      .update({}),

  getPersonOptions: async (caseId: number, query?: string) => {
    const response = await new RemoteData(endpoint.personListOptions({ caseId, query }))
      .resource<ApiResponse<{ rootCodes: RootCode[] }>>()
      .filter({ query })
      .all();
    return response.data.rootCodes;
  }
};
